import { page, onFCP, pageLoad } from '@tkww/ads-content-component-analytics';

let pageData = Object.assign({}, XO.analytics.page_data);

function pageEvent() {
  const category = pageData.category, name = pageData.name;
  delete pageData.category;
  delete pageData.name;

  page(category, name, pageData);
}

const metrics = pageLoad.measure();
pageData.page_load_time = Math.trunc(metrics.page_load_time);
pageData.page_load_time_from_navigation = Math.trunc(metrics.page_load_time_from_navigation);

const timer = setTimeout(() => {
  pageEvent();
}, 500);

onFCP((fcp) => {
  clearTimeout(timer);
  pageData.first_contentful_paint_time = Math.trunc(fcp.value);

  pageEvent();
});
